export type Platform = 'windows' | 'macos' | 'ios' | 'android' | 'linux' | 'web';

function getUserAgent(): string {
  if (typeof navigator === 'undefined') {
    return '';
  }
  return navigator.userAgent ?? '';
}

export function detectPlatform(): Platform {
  const ua = getUserAgent();
  if (/Windows/i.test(ua)) {
    return 'windows';
  }
  if (/Android/i.test(ua)) {
    return 'android';
  }
  if (/iPhone|iPad|iPod/i.test(ua)) {
    return 'ios';
  }
  if (/Macintosh|Mac OS X/i.test(ua)) {
    return 'macos';
  }
  if (/Linux/i.test(ua)) {
    return 'linux';
  }
  return 'web';
}

export function isWindowsDevice(): boolean {
  return detectPlatform() === 'windows';
}
